<template>
  <div class="content display">
    <div>
      <div class="top">
        <!--
        <div style="float:left; position: absolute;">
          <button @click="toggleChartType('type1')" style="padding-left: 10px; padding-right: 10px; padding-top: 3px; padding-bottom: 3px; margin-right: 5px;">차트 타입1</button>
          <button @click="toggleChartType('type2')" style="padding-left: 10px; padding-right: 10px; padding-top: 3px; padding-bottom: 3px;">차트 타입2</button>
        </div>
      -->
          <h1>모바일 근태관리 현황<span class="today">[ {{navigationData.nowYYYY}}.{{navigationData.nowMM}}.{{navigationData.nowDD}} {{navigationData.nowHH}}:{{navigationData.nowMI}}:{{navigationData.nowSS}} ]</span></h1>
        <!-- 현재 시간 -->

      <!-- <span>현재 10초마다 차트가 자동 리프레시됩니다. 만약, 리프레시를 멈추고 싶다면 '리프레시'로 검색해서 아래에서 주석 처리할 부분을 찾아주세요.</span> -->
    </div>
  </div>
    <div class="box_top">
      <ul>
        <li>
          <div class="icon">
            <img src="../../../assets/img/tna/icon_main_top01.jpg">
          </div>
          <div id="workCnt" class="num count-animation">{{webCommuteStatus.workCnt}}</div>
          <div class="txt">출근</div>
        </li>
        <li>
          <div class="icon">
            <img src="../../../assets/img/tna/icon_main_top02.jpg">
          </div>
          <div id="notWorkCnt" class="num count-animation">{{webCommuteStatus.notWorkCnt}}</div>
          <div class="txt">미출근/미체크</div>
        </li>
        <li>
          <div class="icon">
          <img src="../../../assets/img/tna/icon_main_top03.jpg">
          </div>
          <div id="lateWorkCnt" class="num count-animation">{{webCommuteStatus.lateWorkCnt}}</div>
          <div class="txt">지각</div>
        </li>
        <li>
          <div class="icon">
          <img src="../../../assets/img/tna/icon_main_top04.jpg">
          </div>
          <div id="vacationCnt" class="num count-animation">{{webCommuteStatus.vacationCnt}}</div>
          <div class="txt">
          휴가
          </div>
        </li>
      </ul>
    </div>
    <div class="bottom_dashboard">
      <h1>일일 근무시간 리포트<span class="box_date">
        <span id="navigationPrevMonth" v-on:click="onClickNavigationEvent('PREV')" class="k-icon k-i-arrow-chevron-left" v-show="navigationData.isAllowPrevMonth"></span>
        <span id="navigationPrevDummy" style="padding: 0px 30px;" v-show="!navigationData.isAllowPrevMonth"></span>
    		<span id="navigationCurrentMonthText" class="txt_date">{{navigationData.targetYYYY}}.{{navigationData.targetMM}}.{{navigationData.targetDD}}</span>
    		<span id="navigationNextMonth" v-on:click="onClickNavigationEvent('NEXT')" class="k-icon k-i-arrow-chevron-right" v-show="navigationData.isAllowNextMonth"></span>
        <span id="navigationNextDummy" style="padding: 0px 14px;" v-show="!navigationData.isAllowNextMonth"></span>
    		<span id="navigationNowMonth" v-on:click="onClickNavigationEvent('NOW')" class="btn_month">오늘</span>
      </span></h1>

      <div class="no_date" v-show="!displayChart1 && !displayChart2 && !displayChart3 && !displayChart4&& !displayChart5">
        차트 데이터가 존재하지 않습니다.
      </div>

      <!-- 근태 대시보드 차트 타입1 시작 -->
      <ul>
      <li class="chart" v-show="displayType1 && displayChart1">
        <kendo-chart id="overtimeReportCharts1"
                     ref="overtimeReportChartsRef1"
                     :title-text="''"
                     :legend-visible="false"
                     :series-defaults-type="'bar'"
                     :series="chartData1.series"
                     :category-axis="chartData1.categoryAxis"
                     :value-axis="chartData1.valueAxis"
                     :tooltip="chartData1.tooltip"
                     :theme="'sass'"
                     style="">
        </kendo-chart>
      </li>
      <li class="chart" v-show="displayType1 && displayChart2">
        <kendo-chart id="overtimeReportCharts2"
                     ref="overtimeReportChartsRef2"
                     :title-text="''"
                     :legend-visible="false"
                     :series-defaults-type="'bar'"
                     :series="chartData2.series"
                     :category-axis="chartData2.categoryAxis"
                     :value-axis="chartData2.valueAxis"
                     :tooltip="chartData2.tooltip"
                     :theme="'sass'"
                     style="">
        </kendo-chart>
      </li>
      <li class="chart" v-show="displayType1 && displayChart3">
        <kendo-chart id="overtimeReportCharts3"
                     ref="overtimeReportChartsRef3"
                     :title-text="''"
                     :legend-visible="false"
                     :series-defaults-type="'bar'"
                     :series="chartData3.series"
                     :category-axis="chartData3.categoryAxis"
                     :value-axis="chartData3.valueAxis"
                     :tooltip="chartData3.tooltip"
                     :theme="'sass'"
                     style="">
        </kendo-chart>
      </li>
      <li class="chart" v-show="displayType1 && displayChart4">
        <kendo-chart id="overtimeReportCharts4"
                     ref="overtimeReportChartsRef4"
                     :title-text="''"
                     :legend-visible="false"
                     :series-defaults-type="'bar'"
                     :series="chartData4.series"
                     :category-axis="chartData4.categoryAxis"
                     :value-axis="chartData4.valueAxis"
                     :tooltip="chartData4.tooltip"
                     :theme="'sass'"
                     style="">
        </kendo-chart>
      </li>
      <li class="chart" v-show="displayType1 && displayChart5">
        <kendo-chart id="overtimeReportCharts5"
                     ref="overtimeReportChartsRef5"
                     :title-text="''"
                     :legend-visible="false"
                     :series-defaults-type="'bar'"
                     :series="chartData5.series"
                     :category-axis="chartData5.categoryAxis"
                     :value-axis="chartData5.valueAxis"
                     :tooltip="chartData5.tooltip"
                     :theme="'sass'"
                     style="">
        </kendo-chart>
      </li>
    </ul>
  </div>
  <!-- 근태 대시보드 차트 타입1 종료 -->

  <div class="bottom_dashboard2">

  <!-- 근태 대시보드 차트 타입2 시작 -->
    <ul>
      <li class="chart" v-show="displayType2 && displayChart1">
        <kendo-chart ref="overtimeReportCharts1Type2Ref"
                     id="overtimeReportCharts1Type2"
                     :title-text="''"
                     :series-defaults-labels-visible="true"
                     :series-defaults-labels-from-template="config.type2.fromTemplate"
                     :series-defaults-labels-to-template="config.type2.toTemplate"
                     :series="chartData1Type2.series"
                     :value-axis-labels-format="'{0}시'"
                     :value-axis-line-visible="false"
                     :value-axis-axis-crossing-value="'-10'"
                     :category-axis-categories="chartData1Type2.categories"
                     :category-axis-labels-rotation="'auto'"
                     :tooltip-visible="true"
                     :tooltip-template="config.type2.tooltipTemplate"
                     :theme="'sass'">
        </kendo-chart>
      </li>

      <li class="chart" v-show="displayType2 && displayChart2">
        <kendo-chart ref="overtimeReportCharts2Type2Ref"
                     id="overtimeReportCharts2Type2"
                     :title-text="''"
                     :series-defaults-labels-visible="true"
                     :series-defaults-labels-from-template="config.type2.fromTemplate"
                     :series-defaults-labels-to-template="config.type2.toTemplate"
                     :series="chartData2Type2.series"
                     :value-axis-labels-format="'{0}시'"
                     :value-axis-line-visible="false"
                     :value-axis-axis-crossing-value="'-10'"
                     :category-axis-categories="chartData2Type2.categories"
                     :category-axis-labels-rotation="'auto'"
                     :tooltip-visible="true"
                     :tooltip-template="config.type2.tooltipTemplate"
                     :theme="'sass'">
        </kendo-chart>
      </li>

      <li class="chart" v-show="displayType2 && displayChart3">
        <kendo-chart ref="overtimeReportCharts3Type2Ref"
                     id="overtimeReportCharts3Type2"
                     :title-text="''"
                     :series-defaults-labels-visible="true"
                     :series-defaults-labels-from-template="config.type2.fromTemplate"
                     :series-defaults-labels-to-template="config.type2.toTemplate"
                     :series="chartData3Type2.series"
                     :value-axis-labels-format="'{0}시'"
                     :value-axis-line-visible="false"
                     :value-axis-axis-crossing-value="'-10'"
                     :category-axis-categories="chartData3Type2.categories"
                     :category-axis-labels-rotation="'auto'"
                     :tooltip-visible="true"
                     :tooltip-template="config.type2.tooltipTemplate"
                     :theme="'sass'">
        </kendo-chart>
      </li>

      <li class="chart" v-show="displayType2 && displayChart4">
        <kendo-chart ref="overtimeReportCharts4Type2Ref"
                     id="overtimeReportCharts4Type2"
                     :title-text="''"
                     :series-defaults-labels-visible="true"
                     :series-defaults-labels-from-template="config.type2.fromTemplate"
                     :series-defaults-labels-to-template="config.type2.toTemplate"
                     :series="chartData4Type2.series"
                     :value-axis-labels-format="'{0}시'"
                     :value-axis-line-visible="false"
                     :value-axis-axis-crossing-value="'-10'"
                     :category-axis-categories="chartData4Type2.categories"
                     :category-axis-labels-rotation="'auto'"
                     :tooltip-visible="true"
                     :tooltip-template="config.type2.tooltipTemplate"
                     :theme="'sass'">
        </kendo-chart>
      </li>
      <li class="chart" v-show="displayType2 && displayChart5">
        <kendo-chart ref="overtimeReportCharts5Type2Ref"
                     id="overtimeReportCharts5Type2"
                     :title-text="''"
                     :series-defaults-labels-visible="true"
                     :series-defaults-labels-from-template="config.type2.fromTemplate"
                     :series-defaults-labels-to-template="config.type2.toTemplate"
                     :series="chartData5Type2.series"
                     :value-axis-labels-format="'{0}시'"
                     :value-axis-line-visible="false"
                     :value-axis-axis-crossing-value="'-10'"
                     :category-axis-categories="chartData5Type2.categories"
                     :category-axis-labels-rotation="'auto'"
                     :tooltip-visible="true"
                     :tooltip-template="config.type2.tooltipTemplate"
                     :theme="'sass'">
        </kendo-chart>
      </li>
    </ul>
  </div>
  <!-- 근태 대시보드 차트 타입2 종료 -->

  </div>
</template>

<script>
import EtnersCommonUtil from '@/common/etners.common.util'
import EtnersParseUtil from '@/common/etners.parse.util'
import EtnersKendoGridUtil from '@/common/kendo.grid.util'

import EtnersDeptUtil from '@/common/etners.dept.util'

import EtnersDateTimeUtil from '@/common/etners.datetime.util'
import KendoDateTimeUtil from '@/common/kendo.datetime.util'

/* Kendo Excel Export Module */
import { saveExcel } from '@progress/kendo-vue-excel-export'
import { process, filterBy } from '@progress/kendo-data-query'

/**
 * JQuery 모듈 로딩.
 *
 * JQuery 모듈은 Selector 용도로 사용하거나,
 * 부득이하게 Kendo의 css 를 제어해야하는 경우 사용한다.
 *
 * Vue에서 JQuery를 사용하지 못할 이유는 없지만
 * Vue로 상태 제어 및 이벤트 처리하도록 구현해둔 DOM 영역을 JQuery로 직접 건드리게 되면
 * Vue가 사용하는 가상 DOM에는 JQuery로 변경한 부분이 반영되지 않아 문제가 발생할 수 있다는 점을 인지하고 주의해서 사용해야 한다.
 */
import $ from 'jquery'



import ApiUtil from "@/api/api.util"
import ApiConfig from "@/api/api.config"

const platformDomain = ApiConfig.platformDomain
const singleDomain = ApiConfig.singleDomain
const fcmApiDomain = ApiConfig.fcmApiDomain
const tnaApiDomain = location.protocol === 'https:' ? 'https://tna-api.etnersplatform.com':'http://dev-tna-api.etnersplatform.com'


export default {
  name    : 'DailyAttendanceChart',
  created: function() {

    const vm = this

    const refs = vm.$refs

    vm.refreshMainCharts(vm)
  },
  mounted: function() {
    const vm = this

    vm.refreshDateTime()

    //const url = `${tnaApiDomain}/v1/ebmp/tna/web/dashboard/getDashboardStatusForEtnersrnd.json`
    //const url = `http://172.16.0.200:8088/v1/ebmp/tna/web/dashboard/getDashboardStatusForEtnersrnd.json`
    const url = `https://tna-api.etnersplatform.com/v1/ebmp/tna/web/dashboard/getDashboardStatusForEtnersrnd.json`
    //const url = `https://tna-api.etnersplatform.com/v1/ebmp/tna/web/dashboard/getDashboardStatusForAll.json`


    let params = {
      loginUserToken : sessionStorage.getItem('lutk'),
      currentSolcd : 1001
    }

    ApiUtil.post(url, params)
      .then(response => {
        if(response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert("데이터를 정상적으로 받아오지 못했습니다.");

          return false
        }

        const resultStatus = response.data.resultStatus

        if(resultStatus.messageCode !== "2000") {
          kendo.alert(resultStatus.messageText)

          return false
        }

        let webCommuteStatus  = response.data.resultData.webCommuteStatus

        vm.webCommuteStatus.workCnt = webCommuteStatus.workCnt
        vm.webCommuteStatus.notWorkCnt = webCommuteStatus.notWorkCnt
        vm.webCommuteStatus.lateWorkCnt = webCommuteStatus.lateWorkCnt
        vm.webCommuteStatus.vacationCnt = webCommuteStatus.vacationCnt

        let webApprovalStatus = response.data.resultData.webApprovalStatus

        vm.webApprovalStatus.commuteCnt = webApprovalStatus.commuteCnt
        vm.webApprovalStatus.vacationCnt = webApprovalStatus.vacationCnt
        vm.webApprovalStatus.overtimeCnt = webApprovalStatus.overtimeCnt
        vm.webApprovalStatus.etcCnt = webApprovalStatus.etcCnt

        vm.currentDateStatus.currentTodayText = response.data.resultData.currentTodayText
        vm.currentDateStatus.currentYYYY = response.data.resultData.currentYYYY
        vm.currentDateStatus.currentWeekNumber = response.data.resultData.currentWeekNumber

        console.log(`vm.webCommuteStatus.workCnt : ${vm.webCommuteStatus.workCnt}`)

        let delay = 400

        vm.countAnimation("workCnt", webCommuteStatus.workCnt, delay)
        vm.countAnimation("notWorkCnt", webCommuteStatus.notWorkCnt, delay)
        vm.countAnimation("lateWorkCnt", webCommuteStatus.lateWorkCnt, delay)
        vm.countAnimation("vacationCnt", webCommuteStatus.vacationCnt, delay)
      })

      //let interval = 1000 * 60 * 3 //3분
      let interval = 1000 * 10 //10초

      //만약 리프레시가 되지 않게 하려면 아래 구문을 주석 처리하세요.
      setTimeout(function() {
        location.reload()
      }, interval)
  },
  updated: function() {

  },
  computed: {

  },
  methods: {
    countAnimation: function(id, targetNumber, durationDelay) {
      if(durationDelay == undefined) {
        durationDelay = 1000
      }

      $({ val : 0 }).animate({ val : targetNumber }, {
         duration: durationDelay,
        step: function() {
          var num = Math.floor(this.val)
          $(`#${id}`).text(num)
        },
        complete: function() {
          var num = Math.floor(this.val)
          $(`#${id}`).text(num)
        }
      })
    },
    toggleChartType: function(type) {
      const vm = this

      vm.$router.push({
        name: 'DailyAttendanceChart',
        params: {
          yyyy: this.navigationData.targetYYYY,
          mm: this.navigationData.targetMM,
          dd: this.navigationData.targetDD,
          chartType : type === 'type1' ? 'type1' : 'type2'
        }
      })

      location.reload()
    },
    refreshDateTime: function() {
      const vm = this

      const nowDate = new Date()

      let nowYYYY = nowDate.getFullYear()

      let nowMM = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMonth() + 1)
      let nowDD = EtnersDateTimeUtil.convertTwoDigit(nowDate.getDate())

      let nowHH = EtnersDateTimeUtil.convertTwoDigit(nowDate.getHours())
      let nowMI = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMinutes())
      let nowSS = EtnersDateTimeUtil.convertTwoDigit(nowDate.getSeconds())

      vm.navigationData.nowYYYY = nowYYYY
      vm.navigationData.nowMM = nowMM
      vm.navigationData.nowDD = nowDD
      vm.navigationData.nowHH = nowHH
      vm.navigationData.nowMI = nowMI
      vm.navigationData.nowSS = nowSS

      setTimeout(function() {
        vm.refreshDateTime()
      }, 1000)
    },
    currentPageSearchData: function() {
      const vm = this
      const refs = vm.$refs

      let currentSearchDataObj = { }

      const filterData = vm.searchStatus.filterData

      if(filterData.sabun != undefined && filterData.sabun !== '') {
        currentSearchDataObj.sabun = filterData.sabun
      }

      if(filterData.empNm != undefined && filterData.empNm !== '') {
        currentSearchDataObj.empNm = filterData.empNm
      }

      if(filterData.deptCd != undefined && filterData.deptCd !== 'ALL') {
        currentSearchDataObj.deptCd = filterData.deptCd
      }

      console.log(`filterData.totalWorkTimeMode : ${filterData.totalWorkTimeMode}`)

      if(filterData.totalWorkTimeMode !== undefined && filterData.totalWorkTimeMode !== '' && filterData.totalWorkTimeMode !== 'ALL') {
        currentSearchDataObj.totalWorkTimeMode = filterData.totalWorkTimeMode
      }

      return currentSearchDataObj
    },
    turnOnNavigation: function(mode) {
      const vm = this
      const refs = this.$refs

      const currentMonthYYYYMMDD = `${this.navigationData.targetYYYY}${this.navigationData.targetMM}${this.navigationData.targetDD}`

      let currentDate = EtnersDateTimeUtil.lookupDateYYYYMMDD(currentMonthYYYYMMDD)

      switch(mode) {
        case "PREV" :
          currentDate.setDate(currentDate.getDate() - 1)
          break
        case "NEXT" :
          currentDate.setDate(currentDate.getDate() + 1)
          break
        case "NOW" :
          currentDate = new Date()
          break
        default :
          throw new Error("잘못된 값입니다.")
      }

      //네비게이션 초기화
      this.navigationData.targetYYYY = currentDate.getFullYear()
      this.navigationData.targetMM = EtnersDateTimeUtil.convertTwoDigit(currentDate.getMonth() + 1)
      this.navigationData.targetDD = EtnersDateTimeUtil.convertTwoDigit(currentDate.getDate())

      //그리드 새로고침
      //this.refreshMainCharts(vm)

      vm.$router.push({
        name: 'DailyAttendanceChart',
        params: {
          yyyy: this.navigationData.targetYYYY,
          mm: this.navigationData.targetMM,
          dd: this.navigationData.targetDD,
          chartType : this.displayType1 ? 'type1' : 'type2'
        }
      })

      location.reload()
    },
    onClickNavigationEvent: function(mode) {
      const vm = this

      vm.turnOnNavigation(mode)
    },
    dynamicGridHeaderText: function(key) {
      if(key === undefined) {
        return ""
      }



      if(key.indexOf("week_") != -1) {
          let weekNumber = key.substring(5, 7)
          let firstDayYYYYMMDD = key.substring(8, 16)

          //주차 값이 10 이하인 경우 한 자리수가 되어 발생하는 문제를 수정한다.
          if(weekNumber.indexOf("_") != -1) {
            weekNumber = weekNumber.substring(0, 1)
            firstDayYYYYMMDD = key.substring(7, 15)
          }

          let firstDateObj = EtnersDateTimeUtil.lookupDateYYYYMMDD(firstDayYYYYMMDD)
          let lastDateObj = EtnersDateTimeUtil.lookupDateYYYYMMDD(firstDayYYYYMMDD)

          lastDateObj.setDate(firstDateObj.getDate() + 6)

          return `${weekNumber}주차 (${EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(firstDateObj)}~${EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(lastDateObj)})`
      }


      return key
    },
    refreshMainCharts: function(vm) {
      console.log(`refreshMainCharts !!`)

      if(vm == undefined) {
        throw new Error("vm 값을 인자로 넘겨줘야만 실행이 가능합니다.")
      }

      const refs = vm.$refs

      if(refs == undefined) {
        throw new Error("refs 값이 존재해야만 실행이 가능합니다.")
      }

      const route = this.$route

      let chartType = route.params.chartType

      let chartType1Fl = chartType === 'type1' ? true : false

      if(chartType1Fl) {
        vm.refreshChartType1(vm)
      } else {
        vm.refreshChartType2(vm)
      }

    },
    refreshChartType1: function(vm) {
      console.log(`refreshChartType1 !!`)
      const refs = vm.$refs

      const searchData = vm.currentPageSearchData()

      //const url = `${tnaApiDomain}/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`
      //const url = `http://172.16.0.200:8088/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`
      const url = `https://tna-api.etnersplatform.com/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`

        let params = {
          loginUserToken : sessionStorage.getItem('lutk'),
          yyyymmdd : `${vm.navigationData.targetYYYY}${vm.navigationData.targetMM}${vm.navigationData.targetDD}`,
          deptCd : '00_03',
          empNm : searchData.empNm == undefined ? null : searchData.empNm,
          sabun : searchData.sabun == undefined ? null : searchData.sabun
        }

        //Post-Ajax Start
        ApiUtil.post(url, params)
          .then(response => {

            if(response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert("데이터를 정상적으로 받아오지 못했습니다.")

              return false
            }

            const resultStatus = response.data.resultStatus

            if(resultStatus.messageCode !== "2000") {
              kendo.alert(resultStatus.messageText)

              return false
            }

            const resultData = response.data.resultData
            const chartSeriesDataArray1 = new Array()
            const chartSeriesDataArray2 = new Array()
            const chartSeriesDataArray3 = new Array()
            const chartSeriesDataArray4 = new Array()
            const chartSeriesDataArray5 = new Array()

            const chartCategoryDataArray1 = new Array()
            const chartCategoryDataArray2 = new Array()
            const chartCategoryDataArray3 = new Array()
            const chartCategoryDataArray4 = new Array()
            const chartCategoryDataArray5 = new Array()

            let maxHours = 0
            let userCount = resultData.length

            for(let j=0; j < userCount; j++) {
              let row = resultData[j]

              const totalHours = EtnersDateTimeUtil.convertGapTimeToHours(row.nowTotMin)

              if(maxHours < totalHours) {
                maxHours = totalHours
              }

              const displayText = `${row.empNm} ${row.psnScnNm}\n[${row.deptNm}]`

              console.log(`${displayText} : ${totalHours}`)

              console.log(`${JSON.stringify(row)}`)

              switch(row.deptNm) {
                case "PD팀" :
                  chartSeriesDataArray1.push(totalHours)
                  chartCategoryDataArray1.push(displayText)
                  break
                // case "PD2팀" :
                //   chartSeriesDataArray2.push(totalHours)
                //   chartCategoryDataArray2.push(displayText)
                //   break
                case "PM팀" :
                  chartSeriesDataArray3.push(totalHours)
                  chartCategoryDataArray3.push(displayText)
                  break
                case "UX디자인팀" :
                  chartSeriesDataArray4.push(totalHours)
                  chartCategoryDataArray4.push(displayText)
                  break
                case "PL팀" :
                  chartSeriesDataArray5.push(totalHours)
                  chartCategoryDataArray5.push(displayText)
                  break
              }

            }

            if(chartSeriesDataArray1.length == 0) {
              vm.displayChart1 = true
            }

            // if(chartSeriesDataArray2.length == 0) {
            //   vm.displayChart2 = true
            // }

            if(chartSeriesDataArray3.length == 0) {
              vm.displayChart3 = true
            }

            if(chartSeriesDataArray4.length == 0) {
              vm.displayChart4 = true
            }

            if(chartSeriesDataArray5.length == 0) {
              vm.displayChart5 = true
            }

            for(let i=0; i < 5; i++) {
              let currentChartData
              let overtimeReportChartsRef
              let currentChartSeriesDataArray
              let currentChartCategoryDataArray

              switch(i) {
                case 0 :
                  currentChartData = vm.chartData1
                  overtimeReportChartsRef = refs.overtimeReportChartsRef1.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray1
                  currentChartCategoryDataArray = chartCategoryDataArray1
                  break


                case 1 :
                  currentChartData = vm.chartData2
                  overtimeReportChartsRef = refs.overtimeReportChartsRef2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray2
                  currentChartCategoryDataArray = chartCategoryDataArray2
                  break

                case 2 :
                  currentChartData = vm.chartData3
                  overtimeReportChartsRef = refs.overtimeReportChartsRef3.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray3
                  currentChartCategoryDataArray = chartCategoryDataArray3
                  break

                case 3 :
                  currentChartData = vm.chartData4
                  overtimeReportChartsRef = refs.overtimeReportChartsRef4.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray4
                  currentChartCategoryDataArray = chartCategoryDataArray4
                  break

                case 4 :
                  currentChartData = vm.chartData5
                  overtimeReportChartsRef = refs.overtimeReportChartsRef5.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray5
                  currentChartCategoryDataArray = chartCategoryDataArray5
                  break

              }

              currentChartData.series = [
                {
                  name : "총 근로시간",
                  data : currentChartSeriesDataArray
                }
              ]

              currentChartData.categoryAxis.categories = currentChartCategoryDataArray
            }

            let chartMaxNumber = 18

            vm.chartData1.valueAxis = [
              {
                min: 0,
                max: chartMaxNumber,
                line : { visible : true },
                minorGridLines : { visible : true },
                labels : {
                  rotation : "auto",
                  position : "start"
                }
              }
            ]

            vm.chartData2.valueAxis = [
              {
                min: 0,
                max: chartMaxNumber,
                line : { visible : true },
                minorGridLines : { visible : true },
                labels : {
                  rotation : "auto",
                  position : "start"
                }
              }
            ]

            vm.chartData3.valueAxis = [
              {
                min: 0,
                max: chartMaxNumber,
                line : { visible : true },
                minorGridLines : { visible : true },
                labels : {
                  rotation : "auto",
                  position : "start"
                }
              }
            ]

            vm.chartData4.valueAxis = [
              {
                min: 0,
                max: chartMaxNumber,
                line : { visible : true },
                minorGridLines : { visible : true },
                labels : {
                  rotation : "auto",
                  position : "start"
                }
              }
            ]

            vm.chartData5.valueAxis = [
              {
                min: 0,
                max: chartMaxNumber,
                line : { visible : true },
                minorGridLines : { visible : true },
                labels : {
                  rotation : "auto",
                  position : "start"
                }
              }
            ]



            let height = 65;
            let defaultHeight = 50;
            let width = 50;


            // $("[id=overtimeReportCharts1]").css('height', `${chartSeriesDataArray1.length * height + defaultHeight}px`)
            // $("[id=overtimeReportCharts2]").css('height', `${chartSeriesDataArray2.length * height + defaultHeight}px`)
            // $("[id=overtimeReportCharts3]").css('height', `${chartSeriesDataArray3.length * height + defaultHeight}px`)
            // $("[id=overtimeReportCharts4]").css('height', `${chartSeriesDataArray4.length * height + defaultHeight}px`)

            $("[id^=overtimeReportCharts]").css('height', `260px`)

            let overtimeReportChartsRef1 = refs.overtimeReportChartsRef1.kendoWidget()
            let overtimeReportChartsRef2 = refs.overtimeReportChartsRef2.kendoWidget()
            let overtimeReportChartsRef3 = refs.overtimeReportChartsRef3.kendoWidget()
            let overtimeReportChartsRef4 = refs.overtimeReportChartsRef4.kendoWidget()
            let overtimeReportChartsRef5 = refs.overtimeReportChartsRef5.kendoWidget()

            overtimeReportChartsRef1.redraw()
            overtimeReportChartsRef2.redraw()
            overtimeReportChartsRef3.redraw()
            overtimeReportChartsRef4.redraw()
            overtimeReportChartsRef5.redraw()
          })
          //Post-Ajax Close

      vm.displayType1 = true
      vm.displayType2 = false
    },
    refreshChartType2: function(vm) {
      console.log(`refreshChartType2 !!`)

      const refs = vm.$refs
      const searchData = vm.currentPageSearchData()

      //const url = `${tnaApiDomain}/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`
      //const url = `http://172.16.0.200:8088/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`
      const url = `https://tna-api.etnersplatform.com/v1/ebmp/tna/web/attendance/overtimeReport/getWorktimeChartListForDay.json`

        let params = {
          loginUserToken : sessionStorage.getItem('lutk'),
          yyyymmdd : `${vm.navigationData.targetYYYY}${vm.navigationData.targetMM}${vm.navigationData.targetDD}`,
          deptCd : '00_03',
          empNm : searchData.empNm == undefined ? null : searchData.empNm,
          sabun : searchData.sabun == undefined ? null : searchData.sabun
        }

        //Post-Ajax Start
        ApiUtil.post(url, params)
          .then(response => {

            if(response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert("데이터를 정상적으로 받아오지 못했습니다.")

              return false
            }

            const resultStatus = response.data.resultStatus

            if(resultStatus.messageCode !== "2000") {
              kendo.alert(resultStatus.messageText)

              return false
            }

            const resultData = response.data.resultData

            const chartSeriesDataArray1 = new Array()
            const chartSeriesDataArray2 = new Array()
            const chartSeriesDataArray3 = new Array()
            const chartSeriesDataArray4 = new Array()
            const chartSeriesDataArray5 = new Array()

            const chartCategoryDataArray1 = new Array()
            const chartCategoryDataArray2 = new Array()
            const chartCategoryDataArray3 = new Array()
            const chartCategoryDataArray4 = new Array()
            const chartCategoryDataArray5 = new Array()

            let maxHours = 0
            let userCount = resultData.length

            for(let j=0; j < userCount; j++) {
              let row = resultData[j]

              const totalHours = EtnersDateTimeUtil.convertGapTimeToHours(row.nowTotMin)

              if(maxHours < totalHours) {
                maxHours = totalHours
              }

              const displayText = `${row.empNm} ${row.psnScnNm}\n[${row.deptNm}]`

              vm.chartDataMap[displayText] = row

              //console.log(`${displayText} : ${totalHours}`)

              console.log(`${JSON.stringify(row)}`)

              let rangeData = [row.gthTmFloat, row.gtwTmFloat]

              //console.log(`\n\nrangeData : ${rangeData}`)

              switch(row.deptNm) {
                case "PD팀" :
                  chartSeriesDataArray1.push(rangeData)
                  chartCategoryDataArray1.push(displayText)
                  break
                // case "PD2팀" :
                //   chartSeriesDataArray2.push(rangeData)
                //   chartCategoryDataArray2.push(displayText)
                //   break
                case "PM팀" :
                  chartSeriesDataArray3.push(rangeData)
                  chartCategoryDataArray3.push(displayText)
                  break
                case "UX디자인팀" :
                  chartSeriesDataArray4.push(rangeData)
                  chartCategoryDataArray4.push(displayText)
                  break
                case "PL팀" :
                  chartSeriesDataArray5.push(rangeData)
                  chartCategoryDataArray5.push(displayText)
                  break
              }

            }

            if(chartSeriesDataArray1.length == 0) {
              vm.displayChart1 = true
            }

            if(chartSeriesDataArray2.length == 0) {
              vm.displayChart2 = false
            }

            if(chartSeriesDataArray3.length == 0) {
              vm.displayChart3 = true
            }

            if(chartSeriesDataArray4.length == 0) {
              vm.displayChart4 = true
            }

            if(chartSeriesDataArray5.length == 0) {
              vm.displayChart5 = true
            }

            for(let i=0; i < 5; i++) {
              let currentChartData
              let overtimeReportChartsRef
              let currentChartSeriesDataArray
              let currentChartCategoryDataArray

              switch(i) {
                case 0 :
                  currentChartData = vm.chartData1Type2
                  //overtimeReportChartsRef = refs.overtimeReportChartsRef1Type2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray1
                  currentChartCategoryDataArray = chartCategoryDataArray1
                  break

                case 1 :
                  currentChartData = vm.chartData2Type2
                  //overtimeReportChartsRef = refs.overtimeReportChartsRef2Type2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray2
                  currentChartCategoryDataArray = chartCategoryDataArray2
                  break


                case 2 :
                  currentChartData = vm.chartData3Type2
                  //overtimeReportChartsRef = refs.overtimeReportChartsRef3Type2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray3
                  currentChartCategoryDataArray = chartCategoryDataArray3
                  break
                case 3 :
                  currentChartData = vm.chartData4Type2
                  //overtimeReportChartsRef = refs.overtimeReportChartsRef4Type2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray4
                  currentChartCategoryDataArray = chartCategoryDataArray4
                  break
                case 4 :
                  currentChartData = vm.chartData5Type2
                  //overtimeReportChartsRef = refs.overtimeReportChartsRef4Type2.kendoWidget()

                  currentChartSeriesDataArray = chartSeriesDataArray5
                  currentChartCategoryDataArray = chartCategoryDataArray5
                  break
              }

              //console.log(`i : ${i}`)

              if(currentChartData != undefined) {
                currentChartData.series = [
                  {
                    type: 'rangeColumn',
                    data : currentChartSeriesDataArray
                  }
                ]

                currentChartData.categories = currentChartCategoryDataArray
              }

            }

            let width = 55
            let defaultHeight = 110

            $("[id=overtimeReportCharts1Type2]").css('width', `${chartSeriesDataArray1.length * width + defaultHeight}px`)
            $("[id=overtimeReportCharts2Type2]").css('width', `${chartSeriesDataArray2.length * width + defaultHeight}px`)
            $("[id=overtimeReportCharts3Type2]").css('width', `${chartSeriesDataArray3.length * width + defaultHeight}px`)
            $("[id=overtimeReportCharts4Type2]").css('width', `${chartSeriesDataArray4.length * width + defaultHeight}px`)
            $("[id=overtimeReportCharts5Type2]").css('width', `${chartSeriesDataArray4.length * width + defaultHeight}px`)

            let height = 630

            $("[id=overtimeReportCharts1Type2]").css('height', `${height}px`)
            $("[id=overtimeReportCharts2Type2]").css('height', `${height}px`)
            $("[id=overtimeReportCharts3Type2]").css('height', `${height}px`)
            $("[id=overtimeReportCharts4Type2]").css('height', `${height}px`)
            $("[id=overtimeReportCharts5Type2]").css('height', `${height}px`)

            // let overtimeReportCharts1Type2Ref = refs.overtimeReportCharts1Type2Ref.kendoWidget()
            // let overtimeReportCharts2Type2Ref = refs.overtimeReportCharts2Type2Ref.kendoWidget()
            // let overtimeReportCharts3Type2Ref = refs.overtimeReportCharts3Type2Ref.kendoWidget()
            // let overtimeReportCharts4Type2Ref = refs.overtimeReportCharts4Type2Ref.kendoWidget()
            //
            // overtimeReportCharts1Type2Ref.redraw()
            // overtimeReportCharts2Type2Ref.redraw()
            // overtimeReportCharts3Type2Ref.redraw()
            // overtimeReportCharts4Type2Ref.redraw()
          })
          //Post-Ajax Close

      vm.displayType1 = false
      vm.displayType2 = true
    },
    onDataBoundForOvertimeReportGrid: function(evt) {
      console.log('::::::::::: onDataBoundForOvertimeReportGrid ::::::::::: onDataBound !!')

      let grid = evt.sender
      let items = evt.sender.items()

      let vm = this


    },
    onChangeForOvertimeReportGrid: function(evt) {
      console.log('::::::::::: onChangeForOvertimeReportGrid ::::::::::: onChange !!')

      const vm = this
      const refs = this.$refs
    },

    //초기화 버튼
    onClickClearSearchOptionBtn: function(evt) {
      console.log(`onClickClearSearchOptionBtn !!`)


      const vm = this

      //그리드 새로고침
      this.refreshMainCharts(vm)
    },

    //검색 버튼
    onClickSearchBtn: function(evt) {
      console.log(`onClickSearchBtn !!`)

      const vm = this

      //그리드 새로고침
      this.refreshMainCharts(vm)
    },

    // 검색 닫기 버튼 클릭 이벤트
    onClickFilterClose: function(e){
      console.log(`onClickFilterClose !!!`)
      this.filterShowHide = !this.filterShowHide
    },
    onChangeDeptMultiColumnCombobox: function(evt) {
      console.log('::::::::::: onChangeDeptMultiColumnCombobox ::::::::::: onChange !!')
      let vm = this
      let refs = vm.$refs

      const selectedIndex = evt.sender.selectedIndex
      const selectedDeptCd = evt.dataItem.lastDeptCd

      vm.searchStatus.baseData.deptCursor = selectedIndex

      vm.searchStatus.filterData.deptCd = selectedDeptCd

      //그리드 새로고침
      this.refreshMainCharts(vm)
    },
    onKeyupSearchSabunInputEvent: function(evt) {
      console.log('::::::::::: onKeyupSearchSabunInputEvent ::::::::::: onKeyup !!')
      this.searchStatus.filterData.sabun = evt.target.value

      let vm = this
      let refs = vm.$refs

      //EnterKey Event
      if (window.event.keyCode == 13) {
        //그리드 새로고침
        this.refreshMainCharts(vm)
      }
    },
    onKeyupSearchEmpNmInputEvent: function(evt) {
      console.log('::::::::::: onKeyupSearchEmpNmInputEvent ::::::::::: onKeyup !!')
      this.searchStatus.filterData.empNm = evt.target.value

      let vm = this
      let refs = vm.$refs

      //EnterKey Event
      if (window.event.keyCode == 13) {
        //그리드 새로고침
        this.refreshMainCharts(vm)
      }
    },
    onChangeTotalWorkTimeButtonGroup: function(evt) {
      console.log(`onChangeTotalWorkTimeButtonGroup !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!`)
      let vm = this
      let refs = vm.$refs

      const additionalServiceButtonGroupCurrentObj = refs.totalWorkTimeButtonGroupRef.kendoWidget().current()
      const additionalServiceButtonGroupIndex = additionalServiceButtonGroupCurrentObj.index()

      let totalWorkTimeMode

      switch(additionalServiceButtonGroupIndex) {
        case 0: //전체
          totalWorkTimeMode = ''
          break
        case 1: //209시간 이하
          totalWorkTimeMode = 'LESS_THAN_209_HOURS'
          break
        case 2: //209시간 초과
          totalWorkTimeMode = 'MORE_THAN_209_HOURS'
          break
      }

      //console.log(`totalWorkTimeMode!!! : ${totalWorkTimeMode}`)

      this.searchStatus.filterData.totalWorkTimeMode = totalWorkTimeMode

      //그리드 새로고침
      this.refreshMainCharts(vm)
    },
    convertToDateText: function(yyyymmdd) {
      const yyyy = yyyymmdd.substring(0, 4)
      const mm = yyyymmdd.substring(4, 6)
      const dd = yyyymmdd.substring(6, 8)

      return `${yyyy}.${mm}.${dd}`
    }

  },
  data: function() {
    let vm = this
    const nowDate = new Date()

    let nowYYYY = nowDate.getFullYear()

    let nowMM = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMonth() + 1)
    let nowDD = EtnersDateTimeUtil.convertTwoDigit(nowDate.getDate())

    let nowHH = EtnersDateTimeUtil.convertTwoDigit(nowDate.getHours())
    let nowMI = EtnersDateTimeUtil.convertTwoDigit(nowDate.getMinutes())
    let nowSS = EtnersDateTimeUtil.convertTwoDigit(nowDate.getSeconds())

    const route = this.$route

    let targetYYYY = route.params.yyyy
    let targetMM = route.params.mm
    let targetDD = route.params.dd



    return {
      chartDataMap : {},
      filterShowHide : false, //상세검색 더보기/닫기 상태값
      displayChart1 : true,
      displayChart2 : false,
      displayChart3 : true,
      displayChart4 : true,
      displayChart5 : true,
      displayType1 : false,
      displayType2 : false,
      navigationData : {
        isAllowPrevMonth : true, //다음달로 넘어갈 화살표 표시 여부를 가리는 플래그
        isAllowNextMonth : true, //다음달로 넘어갈 화살표 표시 여부를 가리는 플래그
        nowDate : nowDate, //이 페이지를 열고 있는 시점의 현재 날짜.
        nowYYYY : nowYYYY, //이 페이지를 열고 있는 시점의 현재 연도.
        nowMM : nowMM,  //이 페이지를 열고 있는 시점의 현재 월값.
        nowDD : nowDD,
        nowHH : nowHH,
        nowMI : nowMI,
        nowSS : nowSS,
        targetYYYY : targetYYYY, //화면에 표시할 대상연도값. 초기 기본값은 오늘이 포함된 연도 데이터.
        targetMM : targetMM, //화면에 표시할 대상월값. 초기 기본값은 오늘이 포함된 월 데이터.
        targetDD : targetDD
      },
      searchStatus : {
        baseData : {
          dynamicMultiColumnsForDept : [],
          dynamicMultiColumnsDeptArray : [],
          deptCursor : 0,
          deptCd : "",
          totalWorkTimeButtonData : [
            { text : "전체" },
            { text : "0~209H" },
            { text : "209H 초과" },
          ]
        },
        filterData : {
          sabun : undefined,
          empNm : undefined,
          deptCd : undefined,
          totalWorkTimeMode : undefined
        }
      },
      chartData1 : {
        series: [
          {
            name: "총 근로시간",
            data: []
          },
        ],
        valueAxis: [{
            max: 0,
            line: {
                visible: true
            },
            minorGridLines: {
                visible: true
            },
            labels: {
                rotation: "auto"
            }
        }],
        categoryAxis: {
            categories: [],
            majorGridLines: {
                visible: true
            }
        },
        tooltip: {
            visible: true,
            template: "#= series.name #: #= value #시간"
        }
      },
      chartData2 : {
        series: [
          {
            name: "총 근로시간",
            data: []
          },
        ],
        valueAxis: [{
            max: 0,
            line: {
                visible: true
            },
            minorGridLines: {
                visible: true
            },
            labels: {
                rotation: "auto"
            }
        }],
        categoryAxis: {
            categories: [],
            majorGridLines: {
                visible: true
            }
        },
        tooltip: {
            visible: true,
            template: "#= series.name #: #= value #시간"
        }
      },
      chartData3 : {
        series: [
          {
            name: "총 근로시간",
            data: []
          },
        ],
        valueAxis: [{
            max: 0,
            line: {
                visible: true
            },
            minorGridLines: {
                visible: true
            },
            labels: {
                rotation: "auto"
            }
        }],
        categoryAxis: {
            categories: [],
            majorGridLines: {
                visible: true
            }
        },
        tooltip: {
            visible: true,
            template: "#= series.name #: #= value #시간"
        }
      },
      chartData4 : {
        series: [
          {
            name: "총 근로시간",
            data: []
          },
        ],
        valueAxis: [{
            max: 0,
            line: {
                visible: true
            },
            minorGridLines: {
                visible: true
            },
            labels: {
                rotation: "auto"
            }
        }],
        categoryAxis: {
            categories: [],
            majorGridLines: {
                visible: true
            }
        },
        tooltip: {
            visible: true,
            template: "#= series.name #: #= value #시간"
        }
      },

      chartData5 : {
        series: [
          {
            name: "총 근로시간",
            data: []
          },
        ],
        valueAxis: [{
            max: 0,
            line: {
                visible: true
            },
            minorGridLines: {
                visible: true
            },
            labels: {
                rotation: "auto"
            }
        }],
        categoryAxis: {
            categories: [],
            majorGridLines: {
                visible: true
            }
        },
        tooltip: {
            visible: true,
            template: "#= series.name #: #= value #시간"
        }
      },


      chartData1Type2 : {
        series: [{
            type: 'rangeColumn',
            data: [ ]
        }],
        yAxis: {
          max: 50
        },
        categories: [ ],

      },

      chartData2Type2 : {
        series: [{
            type: 'rangeColumn',
            data: [ ]
        }],
        yAxis: {
          max: 50
        },
        categories: [ ]
      },

      chartData3Type2 : {
        series: [{
            type: 'rangeColumn',
            data: [ ]
        }],
        yAxis: {
          max: 50
        },
        categories: [ ],
      },

      chartData4Type2 : {
        series: [{
            type: 'rangeColumn',
            data: [ ]
        }],
        yAxis: {
          max: 50
        },
        categories: [ ],
      },
      chartData5Type2 : {
        series: [{
            type: 'rangeColumn',
            data: [ ]
        }],
        yAxis: {
          max: 50
        },
        categories: [ ],
      },
      config : {
        type2 : {
          fromTemplate : function(item) {
            //console.log(`item : ${JSON.stringify(item)}`)
            let chartData = vm.chartDataMap[item.category]

            let gthTmHHMI = chartData.gthTmHHMI

            return `${gthTmHHMI.substring(0, 2)}시 ${gthTmHHMI.substring(2, 4)}분`
          },
          toTemplate : function(item) {
            let chartData = vm.chartDataMap[item.category]

            let gtwTmHHMI = chartData.gtwTmHHMI

            return `${gtwTmHHMI.substring(0, 2)}시 ${gtwTmHHMI.substring(2, 4)}분`
          },
          tooltipTemplate : function(item) {

            let chartData = vm.chartDataMap[item.category]

            let gthTmHHMI = chartData.gthTmHHMI
            let gthTMHH = gthTmHHMI.substring(0, 2)
            let gthTMMI = gthTmHHMI.substring(2, 4)

            let gtwTmHHMI = chartData.gtwTmHHMI
            let gtwTMHH = gtwTmHHMI.substring(0, 2)
            let gtwTMMI = gtwTmHHMI.substring(2, 4)

            console.log(`chartData.existGthTmFl : ${chartData.existGthTmFl}`)

            if(chartData.existGthTmFl) {
              return `출근시간 : ${gthTMHH}시 ${gthTMMI}분 <br />퇴근시간 : ${gtwTMHH}시 ${gtwTMMI}분`
            } else {
              return `출근시간 : ${gthTMHH}시 ${gthTMMI}분 <br />현재시간 : ${gtwTMHH}시 ${gtwTMMI}분`
            }
          }
          //tooltipTemplate : '출근 시간 : #= value.from # 시 <br> 퇴근시간 : #= value.to # 시',
        }
      },

      webCommuteStatus : {
        workCnt : 0,
        notWorkCnt : 0,
        lateWorkCnt : 0,
        vacationCnt : 0
      },
      webApprovalStatus : {
        commuteCnt : 0,
        vacationCnt : 0,
        overtimeCnt : 0,
        etcCnt : 0
      },
      currentDateStatus : {
        currentTodayText : "",
        currentYYYY : "",
        currentWeekNumber : "",
      },
    }
  }

}
</script>

<style>

</style>
